import React from "react";
import { ISecurityGroup } from "../../redux/security/security.types";
import { useAuth } from "../../contexts/AuthProvider/AuthProvider";
import { useBillingCompanyContext } from "../../providers";

interface IRolesContext {
  roles: ISecurityGroup[];
  roleName: string;
  firstName: string;
  lastName: string;
  sharedEmails: string[];
  userOutletUUID: string;
}

export interface IPremissions extends ISecurityGroup {
  view_access: number;
  edit_access: number;
  bulk_export: number;
  bulk_import: number;
  send_mail: number;
  send_sms: number;
  send_whatsapp: number;
  send_call: number;
}

export const RolesContext = React.createContext<IRolesContext>({
  roles: [],
  roleName: "",
  firstName: "",
  lastName: "",
  sharedEmails: [],
  userOutletUUID: "",
});

export const useRoles = () => React.useContext(RolesContext);

export const RolesProvider: React.FC<{ children: React.ReactNode }> = (
  props,
) => {
  const { user, isLogin, security,  subscribed_plan } = useAuth();
  const {comapny} = useBillingCompanyContext()

  if (!isLogin) {
    return <>{props.children}</>;
  }

  return (
    <RolesContext.Provider
      value={{
        roles: security,
        roleName: user.role_value,
        firstName: user.first_name,
        lastName: user.last_name,
        sharedEmails: user.shared_emails,
        userOutletUUID: comapny.company_outlet_uuid,
      }}
    >
      {props.children}
    </RolesContext.Provider>
  );
};
